import React from 'react'
import {Link} from "react-router-dom";
import '../css/main_style.css';
import Toppart from '../pages/toppart'
import MenuBar from '../pages/Menu'
import Footer from '../pages/Footer'
import Schedules from '../pages/noticeandschedules'
import ApplyContent from '../pages/ApplyContent'

export default function Apply() {
	return(		
		<div id="maincontainer">	
			<Toppart />
			<MenuBar />
			<Schedules />
			<ApplyContent />
			<Footer />	
		</div>	
	)
}

	